export default "__VITE_ASSET__D6wNqdEQ__"